import { DefaultButton, IStackTokens, PrimaryButton, Stack } from '@fluentui/react';
import { Button, Dialog, Flex, Label } from '@fluentui/react-northstar';
import * as microsoftTeams from "@microsoft/teams-js";
import { useBoolean } from '@uifabric/react-hooks';
import * as React from 'react';
import { connect, useDispatch } from 'react-redux';
import hubService from '../../api/services/hub';
import Header from '../../components/Header';
import HubShareDialog from '../../components/HubShare/dialog';
import LazyItem from '../../components/LazyFileItem';
import { HubFile } from '../../model';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { addToMeeting, clearMessage, getMeetingsContents, updateMessage } from '../../store/Meeting/actions';
import { MeetingContent } from '../../store/Meeting/types';
import { getPopularStories } from '../../store/Popular/actions';
import { openWindow } from '../../utils/dialog';
import SearchContent from '../Search';
import SearchContentInMeeting from '../SearchInMeeting';
import styles from './index.module.scss';

const PostMeeting = () => {

    const dispatch = useDispatch();
    const [showShareDialogDesktop, { toggle: toggleShareDialogDesktop, setTrue: hideDialogShareDesktop }] = useBoolean(true);
    const [showShareDialogMobile, { toggle: toggleShareDialogMobile, setTrue: hideDialogShareMobile }] = useBoolean(false);
    const {
        message: refMessage,
        currentMeeting,
        teamEvent,
    } = useTypedSelector((state: ApplicationState) => state.meeting);
    const {
        files
    } = useTypedSelector((state: ApplicationState) => state.story);
    const [currentFiles, setCurrentFiles] = React.useState([] as HubFile[]);
    const [width, setWidth] = React.useState(window.innerWidth);
    const [isMobile, setMobile] = React.useState(false);

    const [attendies, setAttendies] = React.useState([] as {
        email: string,
        name: string,
        status: string
    }[]);

    const [openAddContent, setOpenAddContent] = React.useState(false);
    const [selectedSearchFiles, updateSelectedSearchFile] = React.useState([] as {
        fileId: number;
        storyId: number;
    }[]);
    const addSelectedFileToMeeting = () => {
        selectedSearchFiles.forEach((item) => {
            dispatch(addToMeeting(currentMeeting.id, item.fileId, item.storyId, ''));
        });
        setOpenAddContent(false);
    };

    function handleResize() {
        setWidth(window.innerWidth)
    }

    const [message, setMessage] = React.useState(refMessage);

    React.useEffect(() => {
        if (refMessage && refMessage.length > 0) {
            setMessage(refMessage);
            setTimeout(() => {
                dispatch(clearMessage());
            }, 5000);
        } else {
            setMessage('');
        }
    }, [refMessage]);

    React.useEffect(() => {
        window.addEventListener('resize', handleResize)
        if (window.innerWidth <= 767) {
            setMobile(true);
        }
        else {
            setMobile(false);
        }
    }, [window.innerWidth]);

    React.useEffect(() => {
        if (width <= 767) {
            setMobile(true);
        }
        else {
            setMobile(false);
        }
    }, [width]);

    React.useEffect(() => {
        microsoftTeams.initialize(() => {
            hubService.getLoggedInUser().then((profile) => {
                microsoftTeams.getContext((context) => {
                    if (context.chatId) {
                        dispatch(getMeetingsContents(context.chatId));
                        dispatch(getPopularStories());
                    }
                });

            });
        });
    }, []);

    const stackTokens: Partial<IStackTokens> = { childrenGap: 20 };
    let listItems: MeetingContent[] = [];
    if (currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.length > 0) {
        listItems = currentMeeting.meetingContents;
    };

    React.useEffect(() => {
        if (teamEvent) {
            const attendees = teamEvent.attendees.map(c => {
                return {
                    email: c.emailAddress.address,
                    name: c.emailAddress.name,
                    status: c.status.response,
                }
            });
            setAttendies(attendees);
        }
    }, [teamEvent]);

    const onShareAll = () => {
        if (isMobile) {
            toggleShareDialogDesktop();
        }
        else {
            toggleShareDialogDesktop();
        }
    };

    const GetShareStatus = (fileId: number) => {
        if (fileId && currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.length > 0) {
            const item = currentMeeting.meetingContents.filter(c => c.fileId === fileId).map((item) => {
                return {
                    ...files[item.fileId]
                };
            })[0];
            //  const cacheItem = currentFiles.find(c=>c.id === item.id);
            return item.shareStatus;
        };
        //hideDialog();
    };

    const shareSingleItem = (fileId: number, flag: boolean) => {
        if (currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.length > 0) {
            const item = currentMeeting.meetingContents.filter(c => c.fileId === fileId).map((item) => {
                return {
                    ...files[item.fileId]
                };
            })[0];
            //  const cacheItem = currentFiles.find(c=>c.id === item.id);
            if (item && item.shareStatus!='blocked') {
                if (!flag) {
                    setCurrentFiles([...currentFiles.filter(c => c.id !== item.id)]);
                } else {
                    setCurrentFiles([...currentFiles, item]);
                }
            }

        };
        //hideDialog();
    };

    const onItemClicked = (fileId: number) => {
        const hubUrl = `https://app.bigtincan.com/file/p/${fileId}`;
        openWindow(hubUrl);
        // dispatch(selectRecommandationStory(id, filterFiles.map(c=>c.id)))
    }

    const onSuccess = () => {
        dispatch(updateMessage('Content successfully shared'));
    };

    const renderMobile = () => {
        return (
            <>
                <Stack className={styles.rootMobile}>
                    {!openAddContent && <Flex column className={styles.header}>
                        <Header isMobile={true} isShareVisible={true} isShareEnabled={!(currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.length > 0 && currentFiles.length > 0)} onShareclick={onShareAll} onAddFileClick={() => setOpenAddContent(true)} />
                    </Flex>}
                    {openAddContent && <Flex column={true}>
                        <Flex>
                            <SearchContentInMeeting renderBookmarks={false} overRideListHeight={true} onSelectionChange={(data) => updateSelectedSearchFile(data)} />
                        </Flex>
                        <Flex className={styles.btnSearchContent} gap={'gap.small'}>
                            <DefaultButton className={styles.btnCancel} onClick={() => setOpenAddContent(false)}>Cancel</DefaultButton>
                            <PrimaryButton className={styles.btnAdd} disabled={selectedSearchFiles.length === 0} onClick={addSelectedFileToMeeting}>Add Files</PrimaryButton>
                        </Flex>
                    </Flex>}
                    {!openAddContent && <Stack className={styles.container}>
                        <Stack.Item className={styles.title}>
                            <h1>Post Meeting Sharing</h1>
                        </Stack.Item>
                        <Stack.Item verticalFill tokens={stackTokens} className={styles.list}>
                            {listItems.map(row => <div className={styles.wrapFileItem}><LazyItem key={row.fileId} checked={!!currentFiles.find(c => c.id === row.fileId)} hover={false} selected={false} onCheckedChange={(_, flag) => shareSingleItem(row.fileId, flag)} onItemClick={onItemClicked} actionIcon="share" fileId={row.fileId} /> </div>)}
                        </Stack.Item>
                    </Stack>}
                    {message && <Stack className={styles.messageBar}>
                        <Label className={styles.lblMessage}>{message}</Label>
                    </Stack>}
                </Stack>
                <HubShareDialog isMobile={false} subject={teamEvent ? teamEvent.subject : ''} onSuccess={onSuccess} attendee={attendies} files={currentFiles} onDismiss={hideDialogShareDesktop} isOpen={showShareDialogDesktop} />
            </>
        )
    };

    const renderDesktop = () => {
        return (
            <>
                <div className={styles.root}>
                    <Flex column className={styles.root}>
                        <Header isShareVisible={true} isShareEnabled={!(currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.length > 0 && currentFiles.length > 0)} onShareclick={onShareAll} onAddFileClick={() => setOpenAddContent(true)} />
                    </Flex>

                    < Dialog id="fileSearchDialog"
                        open={openAddContent}
                        content={<SearchContent onSelectionChange={(data) => updateSelectedSearchFile(data)} />}
                        footer={{
                            children: (_Component, props) => {
                                const { styles, ...rest } = props
                                return (
                                    <Flex styles={styles}>
                                        <Flex.Item push>
                                            <Button onClick={() => setOpenAddContent(false)} content='Cancel' />
                                        </Flex.Item>
                                        <Button disabled={selectedSearchFiles.length === 0} onClick={addSelectedFileToMeeting} style={{ marginLeft: 5 }} content='Add Files' primary />
                                    </Flex>
                                )
                            },
                        }}
                    />
                    <Stack className={styles.container}>
                        <Stack.Item className={styles.title}>
                            <h1>Post Meeting Sharing</h1>
                        </Stack.Item>
                        <Stack horizontal tokens={stackTokens} className={styles.list}>
                            {listItems.map(row => <div className={styles.wrapFileItem}><LazyItem shareStatus={GetShareStatus(row.fileId)} key={row.fileId} checked={!!currentFiles.find(c => c.id === row.fileId)} hover={false} selected={false} onCheckedChange={(_, flag) => shareSingleItem(row.fileId, flag)} onItemClick={() => { }} actionIcon="share" fileId={row.fileId} /> </div>)}
                        </Stack>
                    </Stack>
                </div>
                <HubShareDialog subject={teamEvent ? teamEvent.subject : ''} onSuccess={onSuccess} attendee={attendies} files={currentFiles} onDismiss={hideDialogShareDesktop} isOpen={showShareDialogDesktop} />
            </>
        )
    };

    return (
        <>
            {isMobile && renderMobile()}
            {!isMobile && renderDesktop()}
        </>
    );
};

export default connect()(PostMeeting);
